(async () => {

  if (!customElements.get('hero-slider-swiper')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);

    class HeroSwiper extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-hero-slider]');
        this.swiperOptions = {
          threshold: 10
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {

          // Update the swiper
          window.addEventListener('shopify:section:load', () => {
            this.swiperElement.update();
            if(this.swiperOptions.navigation) {
              this.swiperElement.navigation.init();
              this.swiperElement.navigation.update();
            }
          });

          // Slide to the slide when a specific block is selected
          window.addEventListener('shopify:block:select', (event) => {
            this.swiperElement.update();
            if (this.swiperOptions.navigation) {
              this.swiperElement.navigation.init();
              this.swiperElement.navigation.update();
            }
            this.handleBlockSelect(event);
          });

          // When on block deselect go to the slide in front-end
          window.addEventListener('shopify:block:deselect', (event) => {
            this.swiperElement.update();
            if (this.swiperOptions.navigation) {
              this.swiperElement.navigation.init();
              this.swiperElement.navigation.update();
            }
            this.handleBlockSelect(event);
          });

        }
        this.init();
      }

      init() {
        this.swiperElement = new Swiper(this.swiperElement, this.swiperOptions);
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleBlockSelect(event) {
        
        // Check if the slide index is set
        if (!("swiperSlideIndex" in event.target.dataset)) { return; }

        // Set the slide index based on loop settings or not
        let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
        if(this.swiperOptions.loop) {
          swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
        }

        // Slide to slide based on the data attribute from the target
        this.swiperElement.slideTo(swipeToSlideIndex, 1000);

      } 
    }
    window.HeroSwiper = HeroSwiper;
    customElements.define('hero-slider-swiper', HeroSwiper);
  }

})();